/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgOrgUnitRetrievePathId, OrgOrgUnitRetrieveStatus200 } from "../types/OrgOrgUnitRetrieve.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orgOrgUnitRetrieve } from "../requests/orgOrgUnitRetrieve.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orgOrgUnitRetrieveQueryKey = (id?: MaybeRefOrGetter<OrgOrgUnitRetrievePathId>) => [{ url: "/api/org/org-unit/:id/", params: { id: id } }] as const;

export type OrgOrgUnitRetrieveQueryKey = ReturnType<typeof orgOrgUnitRetrieveQueryKey>;

export function orgOrgUnitRetrieveQueryOptions(id?: MaybeRefOrGetter<OrgOrgUnitRetrievePathId>, config: Partial<RequestConfig> & { client?: Client } = {}) {
	const queryKey = orgOrgUnitRetrieveQueryKey(id);
	return queryOptions<OrgOrgUnitRetrieveStatus200, ResponseErrorConfig<Error>, OrgOrgUnitRetrieveStatus200>({
		enabled: () => !!toValue(id),
		queryKey,
		queryFn: async ({ signal }) => {
			return orgOrgUnitRetrieve(toValue(id!), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * {@link /api/org/org-unit/:id/}
 */
export function useOrgOrgUnitRetrieve<
	TData = OrgOrgUnitRetrieveStatus200,
	TQueryData = OrgOrgUnitRetrieveStatus200,
	TQueryKey extends QueryKey = OrgOrgUnitRetrieveQueryKey,
>(
	id?: MaybeRefOrGetter<OrgOrgUnitRetrievePathId>,
	options: {
		query?: Partial<UseQueryOptions<OrgOrgUnitRetrieveStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = (resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? orgOrgUnitRetrieveQueryKey(id);

	const query = useQuery(
		{
			...orgOrgUnitRetrieveQueryOptions(id, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<OrgOrgUnitRetrieveStatus200, ResponseErrorConfig<Error>, TData, OrgOrgUnitRetrieveStatus200, TQueryKey>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
